<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-sm">
                        <div class="nk-block-head-content">
                            <h4 class="nk-block-title fw-normal">Create New User</h4>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">
                        <div class="card">
                            <div class="card-inner">
                                <div class="preview-block">
                                    <span class="preview-title-lg overline-title">User Information</span>
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-03">Email</label>
                                                <div class="form-control-wrap">
                                                    <div class="form-icon form-icon-left">
                                                        <em class="icon ni ni-mail"></em>
                                                    </div>
                                                    <input v-model="$v.registeruser.email.$model" type="text" class="form-control" id="default-03">
                                                    <span v-if="$v.registeruser.email.$error" class="error">
                                                        <span v-if="!$v.registeruser.email.required">Email Is Required </span>
                                                        <span v-if="!$v.registeruser.email.email">Email not valid </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-03">User Name</label>
                                                <div class="form-control-wrap">
                                                    <div class="form-icon form-icon-left">
                                                        <em class="icon ni ni-user"></em>
                                                    </div>
                                                    <input v-model="$v.registeruser.username.$model" type="text" class="form-control" id="default-03">
                                                    <span v-if="$v.registeruser.username.$error" class="error">
                                                        <span v-if="!$v.registeruser.username.required">User Name Is Required </span>
                                                        <span v-if="!$v.registeruser.username.maxLength">User Name has maximum Length 20 </span>
                                                        <span v-if="!$v.registeruser.username.strongUserName">Wrong User Name </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">Referrer No</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="$v.registeruser.referrerNo.$model" type="text" class="form-control" id="default-01">
                                                    <span v-if="$v.registeruser.referrerNo.$error" class="error">
                                                        <span v-if="!$v.registeruser.referrerNo.required">Referrer No Is Required </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">First Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.firstName" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">Middle Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.middleName" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">Last Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.lastName" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Mobile</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.phonenumber" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Role</label>
                                                <roledropdown @input="GetRole" />
                                            </div>
                                        </div>
                                    </div>

                                    <hr class="preview-hr">
                                    <span class="preview-title-lg overline-title">Personal Information</span>
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Date Of Birth</label>
                                                <datepicker v-model="registeruser.dateOfBirth" />
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                            <div class="form-group">
                                                <label class="form-label">Gender</label>
                                                <div class="g-4 align-center flex-wrap">
                                                    <div class="g">
                                                        <div class="custom-control custom-radio">
                                                            <input v-model="registeruser.gender" type="radio" class="custom-control-input" value="Male" id="male">
                                                            <label class="custom-control-label" for="male">Male</label>
                                                        </div>
                                                    </div>
                                                    <div class="g">
                                                        <div class="custom-control custom-radio">
                                                            <input v-model="registeruser.gender" type="radio" class="custom-control-input" value="Female" id="female">
                                                            <label class="custom-control-label" for="female">Female</label>
                                                        </div>
                                                    </div>
                                                    <div class="g">
                                                        <div class="custom-control custom-radio">
                                                            <input v-model="registeruser.gender" type="radio" class="custom-control-input" value="Transgender" id="transgender">
                                                            <label class="custom-control-label" for="transgender">Transgender</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" v-if="false">
                                            <div class="form-group">
                                                <label class="form-label">CNIC</label>
                                                <input v-model="registeruser.cnic" type="text" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Passport</label>
                                                <input v-model="registeruser.passport" type="text" class="form-control">
                                            </div>
                                        </div>


                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Country</label>
                                                <country-dropdown v-model="registeruser.country" />
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">City</label>
                                                <input v-model="registeruser.city" type="text" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Street</label>
                                                <input v-model="registeruser.street" type="text" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Postal Code</label>
                                                <input v-model="registeruser.postalCode" type="text" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="form-group">
                                                <label class="form-label">Address</label>
                                                <div class="form-control-wrap">
                                                    <textarea v-model="registeruser.address" class="form-control no-resize"></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Password</label>
                                                <input v-model="$v.registeruser.password.$model" type="password" class="form-control">
                                                <span v-if="$v.registeruser.password.$error" class="error">
                                                    <span v-if="!$v.registeruser.password.required">Password Is Required </span>
                                                    <span v-if="!$v.registeruser.password.strongPassword">Use Strong Password </span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Confirm Password</label>
                                                <input v-model="$v.registeruser.confirmPassword.$model" type="password" class="form-control">
                                                <span v-if="$v.registeruser.confirmPassword.$error" class="error">
                                                    <span v-if="!$v.registeruser.confirmPassword.required">Confirm Password Is Required </span>
                                                    <span v-if="!$v.registeruser.confirmPassword.sameAsPassword">Password Not Matched </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <hr class="preview-hr">
                                    <div class="row gy-4 ">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                            <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser()" class="btn btn-primary" style="margin-right: 10px;"> Save</button>
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required, maxLength, sameAs, email } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default ({
        components: {
            Loading
        },
        name: 'registernewuser',
        data: function () {
            return {
                loading: false,
                registeruser: {
                    id: '00000000-0000-0000-0000-000000000000',
                    email: '',
                    username: '',
                    referrerNo: '',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    phonenumber: '',

                    dateOfBirth: '',
                    gender: '',
                    cnic: '',
                    passport: '',
                    country: '',
                    city: '',
                    street: '',
                    postalCode: '',
                    address: '',
                    roleId: '',
                    roleName: '',

                    password: '',
                    confirmPassword: '',
                }
            }
        },
        validations: {
            registeruser:
            {
                username:
                {
                    required,
                    maxLength: maxLength(20),
                    strongUserName(username) {
                        return /^[a-z0-9_.]+$/.test(username);
                    }
                },
                email:
                {
                    required,
                    email
                },
                referrerNo:
                {
                    required
                },
                password:
                {
                    required,
                    strongPassword(password) {
                        return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);
                    }
                },
                confirmPassword:
                {
                    required,
                    sameAsPassword: sameAs('password')
                },
            }
        },

        methods: {
            GoToList: function () {
                this.$router.push('/UserList')
            },

            GetRole: function (role) {
                this.registeruser.roleId = role.id;
                this.registeruser.roleName = role.name;
            },

            SaveNewUser: function () {
                var root = this;
                this.loading = true;
                
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/account/RegisterUser', this.registeruser, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            
                            root.SendEmailVerification(response.data.id);
                            root.loading = false;
                            root.$swal({
                                title: 'Created!',
                                text: 'User has been Created successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.GoToList();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

            SendEmailVerification: function (id) {
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                
                this.$https.get('/account/SendEmailVerification?id=' + id, { headers: { "Authorization": `Bearer ${token}` } });
                   
            },

        },

    })
</script>
